import { baseAxios, errorHandler } from "../index";

export async function tambahCabang(data) {
  try {
    const response = await baseAxios.post("webCabang/tambahCabang", data, {
      headers: {
        token: localStorage.getItem("token"),
      },
    });
    return response;
  } catch (err) {
    console.log("error upload", err);
    return errorHandler(err.response);
  }
}

export async function getAllCabang(dispatch, data) {
  try {
    const response = await baseAxios.get(
      `webCabang/getAllCabang?idClient=${data.idClient}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_ALLCABANG", data: response.data });
    return response.status;
  } catch (err) {
    // console.log(err.response, "errorrr");
    return errorHandler(err.response);
  }
}

export async function getAllAnggotaCabang(dispatch, data) {
  try {
    const response = await baseAxios.get(
      `webCabang/getAllAnggotaCabang?idCabang=${data.idCabang}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_ALLANGGOTACABANG", data: response.data });
    return response.status;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function tambahTargetCabang(data) {
  try {
    const response = await baseAxios.post(
      "webCabang/tambahTargetCabang",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      },
    );
    return response;
  } catch (err) {
    console.log("error upload", err);
    return errorHandler(err.response);
  }
}

export async function getAllTargetCabang(dispatch, data, history) {
  try {
    const response = await baseAxios(
      `webCabang/getAllTargetCabang?idClient=${data.idClient}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_ALL_TARGET_CABANG", data: response.data });
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function editTargetCabang(data) {
  try {
    const response = await baseAxios.patch("webCabang/ubahTargetCabang", data, {
      headers: { token: localStorage.getItem("token") },
    });
    return response.data;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllCabangKoor(dispatch, data) {
  try {
    const response = await baseAxios.get("webCabang/getCabangKoor", {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_ALLCABANG_KOOR", data: response.data.data });
    return response.status;
  } catch (err) {
    // console.log(err.response, "errorrr");
    return errorHandler(err.response);
  }
}

export async function editCabangPencairan(data) {
  try {
    const response = await baseAxios.patch("webCabang/editCabang", data, {
      headers: { token: localStorage.getItem("token") },
    });
    return response.data;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function tambahTargetCabangProduktif(data) {
  try {
    const response = await baseAxios.post(
      "webCabang/tambahTargetCabangProduktif",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      },
    );
    return response;
  } catch (err) {
    console.log("error upload", err);
    return errorHandler(err.response);
  }
}

export async function getAllTargetCabangProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios(
      `webCabang/getAllTargetCabangProduktif?idClient=${data.idClient}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_ALL_TARGET_CABANG_PRODUKTIF", data: response.data });
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function editTargetCabangProduktif(data) {
  try {
    const response = await baseAxios.patch(
      "webCabang/ubahTargetCabangProduktif",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    return response.data;
  } catch (err) {
    return errorHandler(err.response);
  }
}
